import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Join the Adventure!
        </p>
        <p className='footer-subscription-text'>
          For the best deals and personalized experiences, reach out to us directly. Book your <b>FREE TRIAL</b> now!
        </p>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
          navigate='/book-now'
          >
          BOOK NOW
        </Button>
      </section>
      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
              RBW
              <i className='fab fa-typo3' />
            </Link>
          </div>
          <small className='website-rights'>Roblock World © 2024</small>
          <div className='social-icons'>
            <Link
              className='social-icon-link facebook'
              to='https://www.facebook.com/profile.php?id=61565565536767&mibextid=LQQJ4d'
              target='_blank'
              aria-label='Facebook'
            >
              <i className='fab fa-facebook-f' />
            </Link>
            <Link
              className='social-icon-link instagram'
              to='https://www.instagram.com/roblockworld.sg?igsh=azVudGx1Z3U3anc0&utm_source=qr'
              target='_blank'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </Link>
            <Link
              className='social-icon-link youtube'
              to='https://www.youtube.com/@RoblockWorldAcademy'
              target='_blank'
              aria-label='Youtube'
            >
              <i className='fab fa-youtube' />
            </Link>
            <Link
              className='social-icon-link twitter'
              to='https://www.xiaohongshu.com/user/profile/5edbe3540000000001002814?xhsshare=CopyLink&appuid=5ed8bfbb00000000010054ee&apptime=1725630226&share_id=a5e23f886055485880956afd0160eb18'
              target='_blank'
              aria-label='xiaohongshu'
            >
              <i className="fa-solid fa-book"></i>
            </Link>
            <Link
              className='social-icon-link twitter'
              to='https://wa.me/message/XCAPPOTEII6ML1'
              target='_blank'
              aria-label='Whatsapp'
            >
              <i className="fa-brands fa-whatsapp"></i>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;